import { Reducer } from 'redux';

import { Action, ActionType } from '../actionTypes/contractTypeActionTypes';
import { IContractType as ContractType } from '../../models/contract';

export interface IContractTypesState {
    contractTypes: ContractType[];
    loading: boolean;
    error: string | null,
}
const initialState = {
    contractTypes: [],
    loading: false,
    error: null,   
};
export const ContractTypeReducer: Reducer<IContractTypesState, Action> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ActionType.FETCH_CONTRACTTYPES:
            return { ...state, loading: true };

        case ActionType.FETCH_CONTRACTTYPES_FAIL:
            return { 
                ...state, 
                loading: false,
                error: action.payload
            };
        case ActionType.FETCH_CONTRACTTYPES_SUCCESS:
            return {
                ...state,
                contractTypes: action.payload,
                loading: false
            };
            //[ ...state.contracts, ..._.mapKeys(action.payload, 'id')]
        default:
            return state;
    }
};
